import logout from "@/util/logout";
import store from "../../store";
import messages from "../../languages/index";
let lang = localStorage.getItem("language") || store.state.language || "pt";
// ###
// OperatorType
// Retail 0 - Não tem agente, 100 % online (Não tem agentes, Arrecadador, só venda online)
// Retail 1 - Simplificado(Não tem rotas, Arrecadadores, Lançamentos, Prestação de contas)
// Retail 2 - Completo(Agentes, Arrecadadores, rotas...)
// ###
// ###
// Credit - Módulo Crédito
// Credit 1 - Vende crédito no dinheiro com o agente
// Credit 2 - Venda Crédito Online
// ###
// Realiza o get do retail e do credit do operador

var operatorType = localStorage.getItem("operator-retail");
var credit = localStorage.getItem("operator-credit");

const operator = {
  operatorType: operatorType,
  credit: credit,
};
// Debug Operadores e Credits"
// const operator = {
//   operatorType: 2,
//   credit: 2,
// }
// console.log("operator na rota", operator)
export default {
  name: "regionalManager",
  path: "/regional-manager",
  redirect: {
    name: "RegionalManagerDashboard",
  },
  meta: {
    requiresAuth: true,
    nameDrawer: "Gerente Regional",
  },
  component: () => import("@/views/backoffice/template.vue"),
  beforeEnter: (to, from, next) => {
    const { level } = localStorage;
    level == "regionalManager" ? next() : logout();
  },
  children: [
    //  =================================================================
    //  Group: Dashboard
    //  =================================================================
    {
      name: "RegionalManagerDashboard",
      path: "dashboard",
      meta: {
        nameDrawer: "Dashboard",
        active: true,
        icon: "mdi-view-dashboard",
        group: false,
        operator: true,
      },
      component: () =>
        import("@/views/backoffice/regional-manager/dashboard/home"),
    },
    // Affiliates
    {
      name: "RegionalManagerAffiliates",
      path: "affiliates",
      meta: {
        nameDrawer: messages[lang].affiliates,
        icon: "mdi-account-group",
        operator: operator.credit == 2 ? true : false,
        filters: ["Range", "GroupExport"],
        filterLimitDays: 31,
      },
      component: () =>
        import(
          "@/views/backoffice/regional-manager/accountabilityOnline/"
        ),
      children: [
        {
          name: "RegionalManagerAffiliatesExtract",
          path: "extract",
          redirect: {
            name: "RegionalManagerAffiliatesRenevueShare"
          },
          meta: {
            nameDrawer: messages[lang].extract,
          },
          component: () =>
            import(
              "@/views/backoffice/regional-manager/accountabilityOnline/extractAndCpa/"
            ),
          children: [
            {
              name: "RegionalManagerAffiliatesRenevueShare",
              path: "revenueShare",
              meta: {
                nameDrawer: "Revenue Share",
                filters: ["Range", "GroupExport"],
                filterLimitDays: 31
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/accountabilityOnline/extractAndCpa/extract/"
                )
            },
            {
              name: "RegionalManagerAffiliatesCpa",
              path: "cpa",
              meta: {
                nameDrawer: "CPA",
                filters: [
                  "Range",
                  "AutocompleteLocals",
                  "AutocompleteAgents",
                  "GroupExport"
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/accountabilityOnline/extractAndCpa/cpa/"
                )
            }
          ]
        },
      ],
    },
    //  =================================================================
    //  Group: Bet
    //  =================================================================
    {
      name: "RegionalManagerBet",
      path: "bet",
      meta: {
        nameDrawer: messages[lang].bets,
        icon: "mdi-ticket-confirmation",
        group: true,
        operator: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/regional-manager"),
      children: [
        {
          name: "RegionalManagerBetHistoric",
          path: "historic",
          meta: {
            nameDrawer: messages[lang].historic,
            operator: true,
            filters: [
              "Range",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "SelectStatusBet",
              "SelectResultBet",
              "EventNumber",
            ],
            filterLimitDays: 7,
          },
          component: () =>
            import("@/views/backoffice/regional-manager/bet/historic"),
          children: [
            {
              name: "RegionalManagerBetHistoricLocal",
              path: ":id_local",
              meta: {
                nameDrawer: messages[lang].historyLocalBettingManager,
              },
            },
            {
              name: "RegionalManagerBetHistoricAgent",
              path: ":id_local/:id_agent",
              meta: {
                nameDrawer: "Histórico Apostas Agente",
              },
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Users (See Local Managers and Agents)
    //  =================================================================
    {
      name: "RegionalManagerUsers",
      path: "users",
      meta: {
        nameDrawer: messages[lang].users,

        icon: "mdi-account-multiple",
        group: true,
        operator:
          operator.operatorType == 1 || operator.operatorType == 2
            ? true
            : false,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/regional-manager"),
      children: [
        //
        //
        // Local Managers (Gerentes Locais)
        {
          name: "RegionalManagerUsersLocalManagersList",
          path: "local-managers/list",
          meta: {
            nameDrawer: messages[lang].localManagers,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: ["SelectStatus"],
          },
          component: () =>
            import(
              "@/views/backoffice/regional-manager/users/local-managers/list"
            ),
          children: [
            {
              name: "RegionalManagerUsersLocalManagersCreate",
              path: "create-local-manager",
              meta: {
                nameDrawer: messages[lang].newLocalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/local-managers/update"
                ),
            },
            {
              name: "RegionalManagerUsersLocalManagersEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editLocalManager,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/local-managers/update"
                ),
            },
          ],
        },

        //
        //
        // Collectors (Arrecadadores)
        {
          name: "RegionalManagerUsersCollectorsList",
          path: "collectors/list",
          meta: {
            nameDrawer: messages[lang].collectors,
            operator: operator.operatorType == 2 ? true : false,
          },
          component: () =>
            import("@/views/backoffice/regional-manager/users/collectors/list"),
          children: [
            {
              name: "RegionalManagerUsersCollectorsCreate",
              path: "create-collector",

              meta: {
                nameDrawer: messages[lang].newCollector,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/collectors/update"
                ),
            },
            {
              name: "RegionalManagerUsersCollectorsEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editCollector,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/collectors/update"
                ),
            },
            {
              name: "RegionalManagerUsersCollectorsRoutesToCollect",
              path: "routesToCollect/:id_collector",
              meta: {
                nameDrawer: messages[lang].routesToCollect,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/collectors/routesToCollect"
                ),
            },
          ],
        },

        //
        //
        // Routes (Rotas)
        {
          name: "RegionalManagerUsersRoutesList",
          path: "routes/list",
          meta: {
            nameDrawer: messages[lang].routes,
            operator: operator.operatorType == 2 ? true : false,
          },
          component: () =>
            import("@/views/backoffice/regional-manager/users/routes/list"),
          children: [
            {
              name: "RegionalManagerUsersRoutesCreate",
              path: "create-route",
              meta: {
                nameDrawer: messages[lang].newRoute,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/routes/update"
                ),
            },
            {
              name: "RegionalManagerUsersRoutesEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editRoute,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/routes/update"
                ),
            },
          ],
        },

        //
        //
        // Agents (Agentes)
        {
          name: "RegionalManagerUsersAgentsList",
          path: "agents/list",
          meta: {
            nameDrawer: messages[lang].agents,
            operator:
              operator.operatorType == 1 || operator.operatorType == 2
                ? true
                : false,
            filters: ["AutocompleteLocals", "SelectStatus"],
          },
          component: () =>
            import("@/views/backoffice/regional-manager/users/agents/list"),
          children: [
            {
              name: "RegionalManagerUsersAgentsCreate",
              path: "create-agent",
              meta: {
                nameDrawer: messages[lang].newAgent,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/agents/update"
                ),
            },
            {
              name: "RegionalManagerUsersAgentsEdit",
              path: "edit/:id",
              meta: {
                nameDrawer: messages[lang].editAgent,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/users/agents/update"
                ),
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Financial
    //  =================================================================
    {
      name: "RegionalManagerFinancial",
      path: "financial",
      meta: {
        nameDrawer: messages[lang].accountability,
        // icon: "mdi-cash-usd-outline",
        icon: "mdi-currency-usd",
        operator:
          operator.operatorType == 2 || operator.operatorType == 1
            ? true
            : false,
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/regional-manager"),
      children: [
        {
          name: "RegionalManagerFinancialApuration",
          path: "apuration",
          meta: {
            nameDrawer: messages[lang].generalFinding,
            operator: true,
            fluid: true,
            filters: [
              "Range",
              "AutocompleteLocals",
              "AutocompleteAgents",
              "GroupExport",
            ],
            filterLimitDays: 31,
          },
          component: () =>
            new Promise((resolve) => {
              operator.operatorType == 2
                ? resolve(
                    import(
                      "@/views/backoffice/regional-manager/financial/apuration/apuration"
                    )
                  )
                : resolve(
                    import(
                      "@/views/backoffice/regional-manager/financial/apuration/apurationSimplified"
                    )
                  );
              // store.state.operator.retail == 2 ? resolve(import("@/views/backoffice/regional-manager/financial/apuration/apuration")) :
              //   resolve(import("@/views/backoffice/regional-manager/financial/apuration/apurationSimplified"))
            }),
        },
        {
          name: "RegionalManagerFinancialApurationRoute",
          path: "apurationRoute",
          meta: {
            nameDrawer: messages[lang].routesFinding,
            operator: operator.operatorType == 2 ? true : false,
            fluid: true,
            filters: ["Range", "AutocompleteRoutes", "GroupExport"],
            filterLimitDays: 31,
          },
          component: () =>
            import(
              "@/views/backoffice/regional-manager/financial/apuration/apurationRoute"
            ),
        },
        {
          name: "RegionalManagerFinancialAgents",
          path: "agents",
          meta: {
            nameDrawer: messages[lang].agents,
            operator: operator.operatorType == 2 ? true : false,
            hide: true,
            subGroup: true,
          },
          component: () => import("@/views/backoffice/regional-manager"),
          children: [
            {
              name: "RegionalManagerFinancialAgentsBalance",
              path: "balance",
              meta: {
                nameDrawer: messages[lang].balanceReport,
                operator: true,
                filters: [
                  "AutocompleteLocals",
                  // 'AutocompleteAgents',
                ],
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/financial/agents/balance"
                ),
              children: [
                {
                  name: "RegionalManagerFinancialAgentsBalanceExtractAgent",
                  path: "extract/:id_agent_extract",
                  meta: {
                    nameDrawer: messages[lang].extractAgent,
                    operator: true,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/regional-manager/financial/agents/extractAgent"
                    ),
                },
              ],
            },
            {
              name: "RegionalManagerFinancialListBalanceRoute",
              path: "regionalListBalanceRoute",
              meta: {
                nameDrawer: messages[lang].balancePerRoute,
                operator: true,
                filters: [
                  "AutocompleteRoutes",
                  // 'AutocompleteAgents',
                ],
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/financial/agents/listBalanceRoute"
                ),
              children: [
                {
                  name:
                    "RegionalManagerFinancialAgentsBalanceRouteExtractAgent",
                  path: "extractRoute/:id_agent_extract",
                  meta: {
                    nameDrawer: messages[lang].extractAgent,
                    operator: true,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/regional-manager/financial/agents/extractAgent"
                    ),
                },
              ],
            },
            {
              name: "RegionalManagerFinancialAgentsEntry",
              path: "entry",
              meta: {
                nameDrawer: messages[lang].closings,
                operator: true,
                filters: [
                  "Range",
                  "AutocompleteLocals",
                  "AutocompleteCollectors",
                  "SelectFinancialCategoryAgent",
                ],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/financial/agents/entryHistoric"
                ),
            },
          ],
        },
        {
          name: "RegionalManagerFinancialCollectors",
          path: "collectors",
          meta: {
            nameDrawer: messages[lang].collectors,
            operator: operator.operatorType == 2 ? true : false,
            hide: true,
            subGroup: true,
          },
          component: () => import("@/views/backoffice/regional-manager"),
          children: [
            {
              name: "RegionalManagerFinancialCollectorsCashCollection",
              path: "cash-collection",
              meta: {
                nameDrawer: messages[lang].extract,
                operator: true,
                fluid: true,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/financial/collectors/cashCollection"
                ),
              children: [
                {
                  name:
                    "RegionalManagerFinancialCollectorsCashCollectionCollector",
                  path: ":id_collector",
                  meta: {
                    nameDrawer: messages[lang].cashCollector,
                  },
                },
                {
                  name:
                    "RegionalManagerFinancialCollectorsCashCollectionRoutesToCollect",
                  path: "routesToCollect/:id_collector",
                  meta: {
                    nameDrawer: messages[lang].routesToCollect,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/regional-manager/users/collectors/routesToCollect"
                    ),
                },
                {
                  name:
                    "RegionalManagerFinancialCollectorsCashCollectionSetCash",
                  path: "set-cash/:id_collector",
                  meta: {
                    nameDrawer: messages[lang].newRelease,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/regional-manager/financial/collectors/setCash"
                    ),
                },
                {
                  name:
                    "RegionalManagerFinancialCollectorsCashCollectionExtractAgent",
                  path: "extract/:id_agent_extract",
                  meta: {
                    nameDrawer: messages[lang].extractAgent,
                  },
                  component: () =>
                    import(
                      "@/views/backoffice/regional-manager/financial/agents/extractAgent"
                    ),
                },
              ],
            },
            {
              name: "RegionalManagerFinancialCollectorsEntryHistoric",
              path: "entry-historic",
              meta: {
                nameDrawer: messages[lang].closings,
                operator: true,
                filters: ["Range", "AutocompleteCollectors"],
                filterLimitDays: 31,
              },
              component: () =>
                import(
                  "@/views/backoffice/regional-manager/financial/collectors/entryHistoric"
                ),
              children: [
                {
                  name:
                    "RegionalManagerFinancialCollectorsEntryHistoricCollector",
                  path: ":id_collector",
                  meta: {
                    nameDrawer: messages[lang].collectorReport,
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    //  =================================================================
    //  Group: Account
    //  =================================================================
    {
      name: "RegionalManagerAccount",
      path: "account",
      meta: {
        nameDrawer: messages[lang].accountDrawer,
        operator: true,
        icon: "mdi-badge-account-horizontal",
        group: true,
      },
      //Index (router-view)
      component: () => import("@/views/backoffice/regional-manager"),
      children: [
        {
          name: "RegionalManagerAccountChangePassword",
          path: "changePassword",
          meta: {
            nameDrawer: messages[lang].changePassword,
            operator: true,
          },
          component: () =>
            import("@/views/backoffice/shared/account/changePassword.vue"),
        },
      ],
    },
  ],
};
